export default {"src":"/_next/static/media/0xcd5fe23c85820f7b72d0926fc9b05b43e359b7ee.82a638d4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};